import { withStyles } from '@material-ui/core';
import ReportOpportunity from './ReportOpportunity';
import styles from './styles';

export default withStyles(styles)(ReportOpportunity);
